<template>
  <div class="logo">
    <router-link v-if="type === 'night'" class="router-link" to="/"><img :src="logoDark"/></router-link>
    <router-link v-else class="router-link" to="/"><img :src="logoLight"/></router-link>
  </div>
</template>

<script>
import logoDark from '@/assets/logo.svg';
import logoLight from '@/assets/logo_w.svg';

export default {
  props: {
    type: {
      type: String,
      default: "day",
    }
  },
  data: function () {
    return {
      logoDark: logoDark,
      logoLight: logoLight
    }
  }
}
</script>

<style lang="scss">
.logo {
  width: 120px;
  line-height: 0;

  a.router-link.router-link-active {
    opacity: 1;
  }

  @media (max-width: 767px) {
    width: 54px;
  }
}
</style>



// WEBPACK FOOTER //
// Logo.vue?bac991fe